export const initialText = '# Markdown2PDF\n';
export const initialTextUrl = `${process.env.PUBLIC_URL || '.'}/example/initial.md`;
export const resumeTextUrl = `${process.env.PUBLIC_URL || '.'}/example/resume-cn.md`;
export const resumePhotoTextUrl = `${process.env.PUBLIC_URL || '.'}/example/resume-cn-photo.md`;
export const resumeTemplates = [
  { label: "中文简历（无照片）", url: resumeTextUrl },
  { label: "中文简历（带照片）", url: resumePhotoTextUrl }
];
